
<div>
  <b-modal
    :id="content.idHTML"
    :content-class="content.contentClass"
    body-class="py-0"
    centered
    no-fade
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-header="{ close }">
      <div v-if="content.titre" class="row posBtnFermer">
        <button class="btnClose" @click="close()">
          <svg-icon
            icon-name="icone-fermer-mince"
            color="$couleur-primaire"
            className="iconeFermer"
          ></svg-icon>
        </button>
      </div>
      <h2 class="texte-noir text-center px-2 pt-3 pb-1" v-html="content.titre" />
    </template>
    <div class="graphik_regular body-4 texte-noir text-left px-2 py-1" v-html="content.message" />
    <template #modal-footer>
      <b-row class="row col-12 justify-content-center">
        <b-button
          class="btn-primaire w-xs-auto w-md-auto px-4"
          variant="modal"
          @click="fermerModale()"
        >
          {{ content.libBtnContinuer }}
        </b-button>
      </b-row>
    </template>
  </b-modal>
</div>
